import { DEFAULT_USER_AGENT } from './device.constants';
import { platformInfo } from './device.constants';

export function isAndroidSystem(userAgent: string = DEFAULT_USER_AGENT): boolean {
  return platformInfo?.osName.toLowerCase() === 'android' || /Android/.test(userAgent);
}
